import React, { FC } from 'react'
import styles from './TableRow.module.scss'
import { ITableRow } from '../../../assets/interfaces/tableInterface/index';
type Props = {
    row: ITableRow
}

const TableRow: FC<Props> = ({row}) => {
    return (
        <tr className={styles.row}>
            {
                row.cells.map((cell: any, i:number) => {
                    return (
                        <td key={`${cell}-${i}`} className={styles.cell}>{cell}</td>
                    )
                })
            }
        </tr>
    )
}

export default TableRow